export default __webpack_public_path__ + "static/media/330_portfolio03-jp-mobile.c86cbc07.png";